import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useNavigate } from 'react-router-dom';
import { FaStar } from "react-icons/fa";
import hotelService from '../../services/hotelService';

export default function Fourth() {
  const navigate = useNavigate();
  const firstTenCodes = [157938, 228156, 160456, 8, 159028];
  const [Hotels, setHotels] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const userData = JSON.parse(localStorage.getItem('user_data'));

  useEffect(() => {
    const today = new Date();
    today.setDate(today.getDate() + 5);
    const formattedToday = today.toISOString().split('T')[0];

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const formattedTomorrow = tomorrow.toISOString().split('T')[0];
    setStartDate(formattedToday);
    setEndDate(formattedTomorrow);

    const fetchHotels = async () => {
      try {
        const hotelsData = await Promise.all(
          firstTenCodes.map(async (code) => {
            const contentResponse = await hotelService.getHotelContent(code);
            if (contentResponse && contentResponse.code === code) {
              return {
                code: code,
                name: contentResponse.name?.content || '',
                description: contentResponse.description?.content || '',
                address: contentResponse.address?.content || '',
                city: contentResponse.city?.content || '',
                country: contentResponse.country?.description?.content || '',
                category: contentResponse.category?.description?.content || '',
                accommodationType: contentResponse.accommodationType?.typeMultiDescription?.content || '',
                boards: contentResponse.boards || [],
                facilities: contentResponse.facilities || [],
                images: contentResponse.images || [],
                web: contentResponse.web || '',
                phones: contentResponse.phones || [],
                postalCode: contentResponse.postalCode || '',
                ranking: contentResponse.ranking || 0,
                wildcards: contentResponse.wildcards || []
              };
            }
            return null;
          })
        );
        setHotels(hotelsData.filter(hotel => hotel !== null));
      } catch (error) {
        console.error("Hata oluştu:", error);
      }
    };

    fetchHotels();
  }, []);

  const handleViewDetails = async (hotel) => {
    const currentOccupancies = `%5B%7B"rooms"%3A1%2C"adults"%3A2%2C"children"%3A0%2C"paxes"%3A%5B%5D%7D%5D`;
    
    const params = new URLSearchParams();
    params.set('code', hotel.id || hotel.code); // id veya code kullan
    params.set('slug', hotel.slug || hotel.name?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
    params.set('checkIn', startDate);
    params.set('checkOut', endDate);
    params.set('occupancies', currentOccupancies);
    params.set('nationality', 'SA');
    localStorage.setItem('hotel_code', hotel.code);
    localStorage.setItem('hotel_slug', hotel.name?.toLowerCase().replace(/\s+/g, '-'));
    navigate(`/hotel-detail/${params.get('code')}/${params.get('slug')}?code=${params.get('code')}&slug=${params.get('slug')}&checkIn=${params.get('checkIn')}&checkOut=${params.get('checkOut')}&occupancies=${params.get('occupancies')}&nationality=${params.get('nationality')}`);
    window.scrollTo(0, 0);
  };

  const options = {
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    }
  };
    
return (
<>
    <section className="section place-section bg-white">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-10 wow fadeInUp text-center" data-wow-delay="0.2s">
                    <div className="section-header mb-4 text-center">
                        <h2 className="mb-2">Trending Hotels
                        </h2>
                        <p className="sub-title">Here are some famous tourist places around the world that are known for
                            their historical significance, natural beauty, or cultural impact</p>
                    </div>
                </div>
            </div>
            

            { Hotels?.length > 0 &&
                <div className="" id="Hotels-list">
                    <OwlCarousel className="place-slider nav-center" {...options}>
                    {Hotels.map((hotel,index) => (
                        <div key={index} className="place-item mb-4" style={{
                            height: '400px',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            background: '#fff',
                            cursor: 'pointer'
                        }} onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                        }} onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                        }}>
                            <div className="place-img" style={{ position: 'relative' }}>
                                <a onClick={() => handleViewDetails(hotel)} style={{ display: 'block' }}>
                                    <img 
                                        src={hotel.images?.[0]?.path ? 'https://photos.hotelbeds.com/giata/bigger/' + hotel.images[0].path : ''} 
                                        style={{ 
                                            height: '220px', 
                                            width: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease'
                                        }} 
                                        className="img-fluid" 
                                        alt={hotel.name}
                                        onContextMenu={(e) => e.preventDefault()}
                                        onDragStart={(e) => e.preventDefault()}
                                    />
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                    }}>
                                        {Array.from({ length: parseInt(hotel.category) }, (_, i) => (
                                            <FaStar
                                                key={i}
                                                style={{ 
                                                    color: '#FFD700',
                                                    marginRight: '2px',
                                                    fontSize: '14px'
                                                }}
                                            />
                                        ))}
                                    </div>
                                </a>
                            </div>
                            <div className="place-content" style={{ padding: '20px' }}>
                                <div className="d-flex align-items-center mb-2">
                                    <span className="badge text-capitalize" style={{
                                        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                                        color: '#fff',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        boxShadow: '0 2px 8px rgba(255,165,0,0.2)'
                                    }}>
                                        {hotel.category} Star Hotel
                                    </span>
                                </div>
                                <h5 className="mb-2 text-capitalize" style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    lineHeight: '1.4'
                                }}>
                                    <a onClick={() => handleViewDetails(hotel)} style={{
                                        color: 'inherit',
                                        textDecoration: 'none',
                                        transition: 'color 0.3s ease'
                                    }} onMouseEnter={(e) => e.target.style.color = '#1e88e5'} onMouseLeave={(e) => e.target.style.color = '#2c3e50'}>
                                        {hotel.name?.toLowerCase()}
                                    </a>
                                </h5>
                                <p className="d-flex align-items-center mb-0 text-capitalize" style={{
                                    color: '#666',
                                    fontSize: '14px'
                                }}>
                                    <i className="isax isax-location5 me-2" style={{ color: '#1e88e5' }}></i>
                                    {hotel.city?.toLowerCase()}, {hotel.country?.toLowerCase()}
                                </p>
                                {hotel.description && (
                                    <p className="text-capitalize" style={{
                                        color: '#666',
                                        fontSize: '13px',
                                        marginTop: '12px',
                                        display: '-webkit-box',
                                        WebkitLineClamp: '2',
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        lineHeight: '1.5'
                                    }}>
                                        {hotel.description}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                    </OwlCarousel>
                </div>
              }

        </div>
    </section>
</>
)
}
